import type { AuthLocalization } from '@daveyplate/better-auth-ui';

export const betterAuthLocalizationRo = {
  APP: 'Aplicație',
  ACCOUNT: 'Cont',
  ACCOUNTS: 'Conturi',
  ACCOUNTS_DESCRIPTION: 'Schimbă între conturile în care ești autentificat.',
  ACCOUNTS_INSTRUCTIONS: 'Autentifică-te într-un cont suplimentar.',
  ADD_ACCOUNT: 'Adaugă cont',
  ADD_PASSKEY: 'Adaugă cheie de acces',
  ALREADY_HAVE_AN_ACCOUNT: 'Ai deja un cont?',
  AVATAR: 'Avatar',
  AVATAR_DESCRIPTION:
    'Apasă pe avatar pentru a încărca unul din fișierele tale.',
  AVATAR_INSTRUCTIONS: 'Un avatar este opțional, dar recomandat.',
  BACKUP_CODE_REQUIRED: 'Codul de rezervă este obligatoriu',
  BACKUP_CODES: 'Coduri de rezervă',
  BACKUP_CODES_DESCRIPTION:
    'Salvează aceste coduri de rezervă într-un loc sigur. Le poți folosi dacă pierzi metoda principală de autentificare cu doi factori.',
  BACKUP_CODE_PLACEHOLDER: 'Cod de rezervă',
  BACKUP_CODE: 'Cod de rezervă',
  CANCEL: 'Renunță',
  CHANGE_PASSWORD: 'Schimbă parola',
  CHANGE_PASSWORD_DESCRIPTION: 'Introdu parola curentă și una nouă.',
  CHANGE_PASSWORD_INSTRUCTIONS: 'Folosește cel puțin 8 caractere.',
  CHANGE_PASSWORD_SUCCESS: 'Parola a fost schimbată.',
  CONFIRM_PASSWORD: 'Confirmă parola',
  CONFIRM_PASSWORD_PLACEHOLDER: 'Confirmă parola',
  CONFIRM_PASSWORD_REQUIRED: 'Confirmarea parolei este obligatorie',
  CONTINUE_WITH_AUTHENTICATOR: 'Continuă cu aplicația de autentificare',
  COPIED_TO_CLIPBOARD: 'Copiat în clipboard',
  COPY_TO_CLIPBOARD: 'Copiază în clipboard',
  COPY_ALL_CODES: 'Copiază toate codurile',
  CONTINUE: 'Continuă',
  CURRENT_PASSWORD: 'Parola curentă',
  CURRENT_PASSWORD_PLACEHOLDER: 'Parola curentă',
  CURRENT_SESSION: 'Sesiunea curentă',
  DELETE: 'Șterge',
  DELETE_AVATAR: 'Șterge avatarul',
  DELETE_ACCOUNT: 'Șterge contul',
  DELETE_ACCOUNT_DESCRIPTION:
    'Șterge definitiv contul și tot conținutul aferent. Această acțiune este ireversibilă, continuă cu atenție.',
  DELETE_ACCOUNT_INSTRUCTIONS:
    'Confirmă ștergerea contului. Această acțiune este ireversibilă, continuă cu atenție.',
  DELETE_ACCOUNT_VERIFY: 'Verifică-ți emailul pentru confirmarea ștergerii.',
  DELETE_ACCOUNT_SUCCESS: 'Contul a fost șters.',
  DISABLE_TWO_FACTOR: 'Dezactivează doi factori',
  DISABLED_CREDENTIALS_DESCRIPTION:
    'Alege un furnizor pentru a te conecta la cont.',
  DONT_HAVE_AN_ACCOUNT: 'Nu ai cont?',
  DONE: 'Gata',
  EMAIL: 'Email',
  EMAIL_DESCRIPTION:
    'Introdu adresa de email pe care o folosești la autentificare.',
  EMAIL_INSTRUCTIONS: 'Introdu o adresă de email validă.',
  EMAIL_IS_THE_SAME: 'Emailul este neschimbat',
  EMAIL_PLACEHOLDER: 'm@example.com',
  EMAIL_REQUIRED: 'Adresa de email este obligatorie',
  EMAIL_VERIFY_CHANGE: 'Verifică-ți emailul pentru confirmarea schimbării.',
  EMAIL_VERIFICATION: 'Verifică emailul pentru linkul de confirmare.',
  ENABLE_TWO_FACTOR: 'Activează doi factori',
  IS_INVALID: 'este invalid',
  IS_REQUIRED: 'este obligatoriu',
  IS_THE_SAME: 'este același',
  FORGOT_AUTHENTICATOR: 'Ai uitat aplicația de autentificare?',
  FORGOT_PASSWORD: 'Ai uitat parola',
  FORGOT_PASSWORD_ACTION: 'Trimite linkul de resetare',
  FORGOT_PASSWORD_DESCRIPTION: 'Introdu emailul pentru a reseta parola.',
  FORGOT_PASSWORD_EMAIL: 'Verifică emailul pentru linkul de resetare.',
  FORGOT_PASSWORD_LINK: 'Ți-ai uitat parola?',
  LINK: 'Asociază',
  MAGIC_LINK: 'Magic link',
  MAGIC_LINK_ACTION: 'Trimite magic link',
  MAGIC_LINK_DESCRIPTION: 'Introdu emailul pentru a primi un magic link.',
  MAGIC_LINK_EMAIL: 'Verifică emailul pentru magic link.',
  EMAIL_OTP: 'Cod pe email',
  EMAIL_OTP_SEND_ACTION: 'Trimite codul',
  EMAIL_OTP_VERIFY_ACTION: 'Verifică codul',
  EMAIL_OTP_DESCRIPTION: 'Introdu emailul pentru a primi un cod.',
  EMAIL_OTP_VERIFICATION_SENT: 'Verifică emailul pentru codul de verificare.',
  NAME: 'Nume',
  NAME_DESCRIPTION: 'Introdu numele complet sau numele afișat.',
  NAME_INSTRUCTIONS: 'Folosește maximum 32 de caractere.',
  NAME_PLACEHOLDER: 'Nume',
  NEW_PASSWORD: 'Parola nouă',
  NEW_PASSWORD_PLACEHOLDER: 'Parola nouă',
  NEW_PASSWORD_REQUIRED: 'Parola nouă este obligatorie',
  ONE_TIME_PASSWORD: 'Cod de unică folosință',
  OR_CONTINUE_WITH: 'Sau continuă cu',
  PASSKEY: 'Cheie de acces',
  PASSKEYS: 'Chei de acces',
  PASSKEYS_DESCRIPTION: 'Gestionează cheile de acces pentru login securizat.',
  PASSKEYS_INSTRUCTIONS: 'Accesează contul fără parolă prin chei de acces.',
  PERSONAL_ACCOUNT: 'Cont personal',
  API_KEYS: 'Chei API',
  API_KEYS_DESCRIPTION: 'Gestionează cheile API pentru acces securizat.',
  API_KEYS_INSTRUCTIONS: 'Generează chei API pentru acces programatic.',
  CREATE_API_KEY: 'Creează cheie API',
  CREATE_API_KEY_DESCRIPTION:
    'Alege un nume unic pentru a diferenția această cheie API.',
  API_KEY_NAME_PLACEHOLDER: 'Cheie API nouă',
  API_KEY_CREATED: 'Cheie API creată',
  CREATE_API_KEY_SUCCESS:
    'Copiază cheia API și păstreaz-o într-un loc sigur. Din motive de securitate nu o mai putem afișa.',
  NEVER_EXPIRES: 'Nu expiră',
  EXPIRES: 'Expiră',
  NO_EXPIRATION: 'Fără expirare',
  CREATE_ORGANIZATION: 'Creează organizație',
  ORGANIZATION: 'Organizație',
  ORGANIZATION_NAME: 'Nume',
  ORGANIZATION_NAME_PLACEHOLDER: 'Acme SRL',
  ORGANIZATION_NAME_DESCRIPTION: 'Acesta este numele vizibil al organizației.',
  ORGANIZATION_NAME_INSTRUCTIONS: 'Folosește maximum 32 de caractere.',
  ORGANIZATION_SLUG: 'Slug URL',
  ORGANIZATION_SLUG_DESCRIPTION: 'Acesta este spațiul URL al organizației.',
  ORGANIZATION_SLUG_INSTRUCTIONS: 'Folosește maximum 48 de caractere.',
  ORGANIZATION_SLUG_PLACEHOLDER: 'acme-inc',
  CREATE_ORGANIZATION_SUCCESS: 'Organizația a fost creată.',
  PASSWORD: 'Parolă',
  PASSWORD_PLACEHOLDER: 'Parolă',
  PASSWORD_REQUIRED: 'Parola este obligatorie',
  PASSWORDS_DO_NOT_MATCH: 'Parolele nu coincid',
  PROVIDERS: 'Conturi conectate',
  PROVIDERS_DESCRIPTION:
    'Conectează-ți conturile sociale pentru autentificare rapidă.',
  RECOVER_ACCOUNT: 'Recuperează contul',
  RECOVER_ACCOUNT_ACTION: 'Recuperează contul',
  RECOVER_ACCOUNT_DESCRIPTION:
    'Introdu un cod de rezervă pentru a accesa contul.',
  REMEMBER_ME: 'Ține-mă minte',
  RESEND_CODE: 'Retrimite codul',
  RESEND_VERIFICATION_EMAIL: 'Retrimite emailul de verificare',
  RESET_PASSWORD: 'Resetează parola',
  RESET_PASSWORD_ACTION: 'Salvează parola nouă',
  RESET_PASSWORD_DESCRIPTION: 'Introdu parola nouă mai jos.',
  RESET_PASSWORD_SUCCESS: 'Parola a fost resetată.',
  REQUEST_FAILED: 'Cererea a eșuat',
  REVOKE: 'Revocă',
  DELETE_API_KEY: 'Șterge cheia API',
  DELETE_API_KEY_CONFIRM: 'Sigur vrei să ștergi această cheie API?',
  API_KEY: 'Cheie API',
  SIGN_IN: 'Autentificare',
  SIGN_IN_ACTION: 'Autentifică-te',
  SIGN_IN_DESCRIPTION:
    'Autentifică-te și vezi doar știrile care contează pentru portofoliul tău.',
  SIGN_IN_USERNAME_DESCRIPTION:
    'Introdu numele de utilizator sau emailul pentru autentificare.',
  SIGN_IN_WITH: 'Autentificare cu',
  SIGN_OUT: 'Deconectare',
  SIGN_UP: 'Creează cont',
  SIGN_UP_ACTION: 'Creează un cont',
  SIGN_UP_DESCRIPTION: 'Completează informațiile pentru a crea un cont.',
  SIGN_UP_EMAIL: 'Verifică emailul pentru linkul de confirmare.',
  SESSIONS: 'Sesiuni',
  SESSIONS_DESCRIPTION: 'Gestionează sesiunile active și revocă accesul.',
  SET_PASSWORD: 'Setează parola',
  SET_PASSWORD_DESCRIPTION:
    'Primește pe email un link pentru a seta parola contului.',
  SETTINGS: 'Setări',
  SAVE: 'Salvează',
  SECURITY: 'Securitate',
  SWITCH_ACCOUNT: 'Schimbă contul',
  TRUST_DEVICE: 'Am încredere în acest dispozitiv',
  TWO_FACTOR: 'Autentificare în doi pași',
  TWO_FACTOR_ACTION: 'Verifică codul',
  TWO_FACTOR_DESCRIPTION: 'Introdu codul de unică folosință pentru a continua.',
  TWO_FACTOR_CARD_DESCRIPTION:
    'Adaugă un strat suplimentar de securitate contului tău.',
  TWO_FACTOR_DISABLE_INSTRUCTIONS: 'Introdu parola pentru a dezactiva 2FA.',
  TWO_FACTOR_ENABLE_INSTRUCTIONS: 'Introdu parola pentru a activa 2FA.',
  TWO_FACTOR_ENABLED: 'Autentificarea în doi pași este activată.',
  TWO_FACTOR_DISABLED: 'Autentificarea în doi pași a fost dezactivată.',
  TWO_FACTOR_PROMPT: 'Autentificare în doi pași',
  TWO_FACTOR_TOTP_LABEL: 'Scanează codul QR cu aplicația de autentificare.',
  SEND_VERIFICATION_CODE: 'Trimite codul de verificare',
  UNLINK: 'Dezasociază',
  UPDATED_SUCCESSFULLY: 'Actualizat cu succes',
  USERNAME: 'Nume de utilizator',
  USERNAME_DESCRIPTION:
    'Introdu numele de utilizator folosit la autentificare.',
  USERNAME_INSTRUCTIONS: 'Folosește maximum 32 de caractere.',
  USERNAME_PLACEHOLDER: 'Nume de utilizator',
  SIGN_IN_USERNAME_PLACEHOLDER: 'Nume de utilizator sau email',
  VERIFY_YOUR_EMAIL: 'Verifică-ți emailul',
  VERIFY_YOUR_EMAIL_DESCRIPTION:
    'Verifică adresa de email. Dacă nu ai primit mesajul, apasă mai jos pentru a-l retrimite.',
  GO_BACK: 'Înapoi',
  SESSION_NOT_FRESH: 'Sesiunea nu mai este validă. Autentifică-te din nou.',
  UPLOAD_AVATAR: 'Încarcă avatar',
  LOGO: 'Logo',
  LOGO_DESCRIPTION: 'Apasă pe logo pentru a încărca unul personalizat.',
  LOGO_INSTRUCTIONS: 'Un logo este opțional, dar recomandat.',
  UPLOAD: 'Încarcă',
  UPLOAD_LOGO: 'Încarcă logo',
  DELETE_LOGO: 'Șterge logo',
  PRIVACY_POLICY: 'Politica de confidențialitate',
  TERMS_OF_SERVICE: 'Termeni și condiții',
  PROTECTED_BY_RECAPTCHA: 'Acest site este protejat de reCAPTCHA.',
  BY_CONTINUING_YOU_AGREE: 'Continuând, declari că ești de acord cu',
  USER: 'Utilizator',
  ORGANIZATIONS: 'Organizații',
  ORGANIZATIONS_DESCRIPTION: 'Gestionează organizațiile și rolurile tale.',
  ORGANIZATIONS_INSTRUCTIONS:
    'Creează o organizație pentru a colabora cu alți utilizatori.',
  LEAVE_ORGANIZATION: 'Părăsește organizația',
  LEAVE_ORGANIZATION_CONFIRM: 'Sigur vrei să părăsești această organizație?',
  LEAVE_ORGANIZATION_SUCCESS: 'Ai părăsit organizația.',
  MANAGE_ORGANIZATION: 'Gestionează organizația',
  REMOVE_MEMBER: 'Elimină membrul',
  REMOVE_MEMBER_CONFIRM: 'Sigur vrei să elimini acest membru din organizație?',
  REMOVE_MEMBER_SUCCESS: 'Membrul a fost eliminat.',
  INVITE_MEMBER: 'Invită membru',
  MEMBERS: 'Membri',
  MEMBERS_DESCRIPTION: 'Adaugă sau elimină membri și gestionează rolurile.',
  MEMBERS_INSTRUCTIONS: 'Invită membri noi în organizație.',
  INVITE_MEMBER_DESCRIPTION:
    'Trimite o invitație pentru a adăuga un membru nou în organizație.',
  ROLE: 'Rol',
  SELECT_ROLE: 'Selectează un rol',
  ADMIN: 'Administrator',
  MEMBER: 'Membru',
  GUEST: 'Invitat',
  OWNER: 'Proprietar',
  UPDATE_ROLE_DESCRIPTION: 'Actualizează rolul acestui membru.',
  UPDATE_ROLE: 'Actualizează rolul',
  MEMBER_ROLE_UPDATED: 'Rolul membrului a fost actualizat.',
  SEND_INVITATION: 'Trimite invitația',
  SEND_INVITATION_SUCCESS: 'Invitația a fost trimisă.',
  PENDING_INVITATIONS: 'Invitații în așteptare',
  PENDING_INVITATIONS_DESCRIPTION:
    'Gestionează invitațiile trimise către organizație.',
  PENDING_USER_INVITATIONS_DESCRIPTION:
    'Invitațiile primite de la organizații.',
  CANCEL_INVITATION: 'Anulează invitația',
  INVITATION_CANCELLED: 'Invitația a fost anulată.',
  ACCEPT_INVITATION: 'Acceptă invitația',
  ACCEPT_INVITATION_DESCRIPTION:
    'Ai primit o invitație să te alături unei organizații.',
  INVITATION_ACCEPTED: 'Invitația a fost acceptată.',
  INVITATION_REJECTED: 'Invitația a fost respinsă.',
  ACCEPT: 'Acceptă',
  REJECT: 'Respinge',
  INVITATION_EXPIRED: 'Invitația a expirat.',
  DELETE_ORGANIZATION: 'Șterge organizația',
  DELETE_ORGANIZATION_DESCRIPTION:
    'Șterge definitiv organizația și conținutul ei. Această acțiune este ireversibilă, continuă cu atenție.',
  DELETE_ORGANIZATION_SUCCESS: 'Organizația a fost ștearsă.',
  DELETE_ORGANIZATION_INSTRUCTIONS:
    'Introdu slug-ul organizației pentru a continua:',
  SLUG_REQUIRED: 'Slug-ul organizației este obligatoriu',
  SLUG_DOES_NOT_MATCH: 'Slug-ul nu se potrivește',
  UNKNOWN: 'Necunoscut',
  USER_NOT_FOUND: 'Utilizatorul nu a fost găsit',
  FAILED_TO_CREATE_USER: 'Crearea utilizatorului a eșuat',
  FAILED_TO_CREATE_SESSION: 'Nu s-a putut crea sesiunea',
  FAILED_TO_UPDATE_USER: 'Actualizarea utilizatorului a eșuat',
  FAILED_TO_GET_SESSION: 'Nu s-a putut obține sesiunea',
  INVALID_PASSWORD: 'Parolă invalidă',
  INVALID_EMAIL: 'Email invalid',
  INVALID_EMAIL_OR_PASSWORD: 'Email sau parolă incorecte',
  SOCIAL_ACCOUNT_ALREADY_LINKED: 'Contul social este deja conectat',
  PROVIDER_NOT_FOUND: 'Furnizorul nu a fost găsit',
  INVALID_TOKEN: 'Token invalid',
  ID_TOKEN_NOT_SUPPORTED: 'id_token nu este suportat',
  FAILED_TO_GET_USER_INFO: 'Nu s-au putut obține informațiile utilizatorului',
  USER_EMAIL_NOT_FOUND: 'Emailul utilizatorului nu a fost găsit',
  EMAIL_NOT_VERIFIED: 'Emailul nu este verificat',
  PASSWORD_TOO_SHORT: 'Parola este prea scurtă (minim 8 caractere)',
  PASSWORD_TOO_LONG: 'Parola este prea lungă',
  USER_ALREADY_EXISTS: 'Utilizatorul există deja',
  EMAIL_CAN_NOT_BE_UPDATED: 'Emailul nu poate fi actualizat',
  CREDENTIAL_ACCOUNT_NOT_FOUND: 'Contul de autentificare nu a fost găsit',
  SESSION_EXPIRED: 'Sesiunea a expirat. Autentifică-te pentru a continua.',
  FAILED_TO_UNLINK_LAST_ACCOUNT: 'Nu poți deconecta ultimul cont disponibil',
  ACCOUNT_NOT_FOUND: 'Contul nu a fost găsit',
  USER_ALREADY_HAS_PASSWORD:
    'Utilizatorul are deja o parolă. Folosește-o pentru a șterge contul.',
  YOU_CANNOT_BAN_YOURSELF: 'Nu îți poți bloca propriul cont',
  YOU_ARE_NOT_ALLOWED_TO_CHANGE_USERS_ROLE:
    'Nu ai dreptul să modifici rolul utilizatorilor',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_USERS:
    'Nu ai permisiunea de a crea utilizatori',
  YOU_ARE_NOT_ALLOWED_TO_LIST_USERS: 'Nu ai permisiunea de a lista utilizatori',
  YOU_ARE_NOT_ALLOWED_TO_LIST_USERS_SESSIONS:
    'Nu ai permisiunea de a lista sesiunile utilizatorilor',
  YOU_ARE_NOT_ALLOWED_TO_BAN_USERS: 'Nu ai permisiunea de a bloca utilizatori',
  YOU_ARE_NOT_ALLOWED_TO_IMPERSONATE_USERS:
    'Nu ai permisiunea de a te autentifica în numele altor utilizatori',
  YOU_ARE_NOT_ALLOWED_TO_REVOKE_USERS_SESSIONS:
    'Nu ai permisiunea de a revoca sesiunile utilizatorilor',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_USERS:
    'Nu ai permisiunea de a șterge utilizatori',
  YOU_ARE_NOT_ALLOWED_TO_SET_USERS_PASSWORD:
    'Nu ai permisiunea de a seta parole pentru utilizatori',
  BANNED_USER: 'Ai fost blocat în această aplicație',
  COULD_NOT_CREATE_SESSION: 'Nu s-a putut crea sesiunea',
  ANONYMOUS_USERS_CANNOT_SIGN_IN_AGAIN_ANONYMOUSLY:
    'Utilizatorii anonimi nu se pot autentifica din nou în mod anonim',
  INVALID_METADATA_TYPE: 'metadata trebuie să fie un obiect sau nedefinit',
  REFILL_AMOUNT_AND_INTERVAL_REQUIRED:
    'refillAmount este obligatoriu când este setat refillInterval',
  REFILL_INTERVAL_AND_AMOUNT_REQUIRED:
    'refillInterval este obligatoriu când este setat refillAmount',
  USER_BANNED: 'Utilizatorul este blocat',
  UNAUTHORIZED_SESSION: 'Sesiune neautorizată sau invalidă',
  KEY_NOT_FOUND: 'Cheia API nu a fost găsită',
  KEY_DISABLED: 'Cheia API este dezactivată',
  KEY_EXPIRED: 'Cheia API a expirat',
  USAGE_EXCEEDED: 'Cheia API a depășit limita de utilizare',
  KEY_NOT_RECOVERABLE: 'Cheia API nu poate fi recuperată',
  EXPIRES_IN_IS_TOO_SMALL: 'Valoarea expiresIn este prea mică.',
  EXPIRES_IN_IS_TOO_LARGE: 'Valoarea expiresIn este prea mare.',
  INVALID_REMAINING: 'Numărul rămas este prea mare sau prea mic.',
  INVALID_PREFIX_LENGTH: 'Dimensiunea prefixului este prea mare sau prea mică.',
  INVALID_NAME_LENGTH: 'Dimensiunea numelui este prea mare sau prea mică.',
  METADATA_DISABLED: 'Metadata este dezactivată.',
  RATE_LIMIT_EXCEEDED: 'Limită de rată depășită.',
  NO_VALUES_TO_UPDATE: 'Nu există valori de actualizat.',
  KEY_DISABLED_EXPIRATION: 'Expirarea personalizată a cheii este dezactivată.',
  INVALID_API_KEY: 'Cheie API invalidă.',
  INVALID_USER_ID_FROM_API_KEY:
    'ID-ul de utilizator din cheia API este invalid.',
  INVALID_API_KEY_GETTER_RETURN_TYPE:
    'Getter-ul pentru cheia API a returnat un tip invalid. Se aștepta un string.',
  SERVER_ONLY_PROPERTY:
    'Proprietatea pe care încerci să o setezi poate fi stabilită doar din instanța server a autentificării.',
  VERIFICATION_FAILED: 'Verificarea CAPTCHA a eșuat',
  MISSING_RESPONSE: 'Lipsește răspunsul CAPTCHA',
  UNKNOWN_ERROR: 'A apărut o eroare',
  MISSING_SECRET_KEY: 'Lipsește cheia secretă',
  SERVICE_UNAVAILABLE: 'Serviciul CAPTCHA nu este disponibil',
  OTP_EXPIRED: 'Codul a expirat',
  INVALID_OTP: 'Cod OTP invalid',
  TOO_MANY_ATTEMPTS: 'Prea multe încercări',
  INVALID_OAUTH_CONFIGURATION: 'Configurație OAuth invalidă',
  PASSWORD_COMPROMISED:
    'Parola introdusă a fost compromisă. Alege o altă parolă.',
  INVALID_SESSION_TOKEN: 'Token de sesiune invalid',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_A_NEW_ORGANIZATION:
    'Nu ai permisiunea de a crea o organizație nouă',
  YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_ORGANIZATIONS:
    'Ai atins numărul maxim de organizații',
  ORGANIZATION_ALREADY_EXISTS: 'Organizația există deja',
  ORGANIZATION_NOT_FOUND: 'Organizația nu a fost găsită',
  USER_IS_NOT_A_MEMBER_OF_THE_ORGANIZATION:
    'Utilizatorul nu este membru al organizației',
  YOU_ARE_NOT_ALLOWED_TO_UPDATE_THIS_ORGANIZATION:
    'Nu ai permisiunea de a actualiza această organizație',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_THIS_ORGANIZATION:
    'Nu ai permisiunea de a șterge această organizație',
  NO_ACTIVE_ORGANIZATION: 'Nu există o organizație activă',
  USER_IS_ALREADY_A_MEMBER_OF_THIS_ORGANIZATION:
    'Utilizatorul este deja membru al acestei organizații',
  MEMBER_NOT_FOUND: 'Membrul nu a fost găsit',
  ROLE_NOT_FOUND: 'Rolul nu a fost găsit',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_A_NEW_TEAM:
    'Nu ai permisiunea de a crea o echipă nouă',
  TEAM_ALREADY_EXISTS: 'Echipa există deja',
  TEAM_NOT_FOUND: 'Echipa nu a fost găsită',
  YOU_CANNOT_LEAVE_THE_ORGANIZATION_AS_THE_ONLY_OWNER:
    'Nu poți părăsi organizația fiind singurul proprietar',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_THIS_MEMBER:
    'Nu ai permisiunea de a șterge acest membru',
  YOU_ARE_NOT_ALLOWED_TO_INVITE_USERS_TO_THIS_ORGANIZATION:
    'Nu ai permisiunea de a invita utilizatori în această organizație',
  USER_IS_ALREADY_INVITED_TO_THIS_ORGANIZATION:
    'Utilizatorul este deja invitat în această organizație',
  INVITATION_NOT_FOUND: 'Invitația nu a fost găsită',
  YOU_ARE_NOT_THE_RECIPIENT_OF_THE_INVITATION:
    'Nu ești destinatarul acestei invitații',
  YOU_ARE_NOT_ALLOWED_TO_CANCEL_THIS_INVITATION:
    'Nu ai permisiunea de a anula această invitație',
  INVITER_IS_NO_LONGER_A_MEMBER_OF_THE_ORGANIZATION:
    'Persoana care a invitat nu mai este membră a organizației',
  YOU_ARE_NOT_ALLOWED_TO_INVITE_USER_WITH_THIS_ROLE:
    'Nu ai permisiunea de a invita utilizatori cu acest rol',
  FAILED_TO_RETRIEVE_INVITATION: 'Nu s-a putut prelua invitația',
  YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_TEAMS:
    'Ai atins numărul maxim de echipe',
  UNABLE_TO_REMOVE_LAST_TEAM: 'Ultima echipă nu poate fi ștearsă',
  YOU_ARE_NOT_ALLOWED_TO_UPDATE_THIS_MEMBER:
    'Nu ai permisiunea de a actualiza acest membru',
  ORGANIZATION_MEMBERSHIP_LIMIT_REACHED:
    'A fost atins numărul maxim de membri ai organizației',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_TEAMS_IN_THIS_ORGANIZATION:
    'Nu ai permisiunea de a crea echipe în această organizație',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_TEAMS_IN_THIS_ORGANIZATION:
    'Nu ai permisiunea de a șterge echipe în această organizație',
  YOU_ARE_NOT_ALLOWED_TO_UPDATE_THIS_TEAM:
    'Nu ai permisiunea de a actualiza această echipă',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_THIS_TEAM:
    'Nu ai permisiunea de a șterge această echipă',
  INVITATION_LIMIT_REACHED: 'Limita de invitații a fost atinsă',
  CHALLENGE_NOT_FOUND: 'Provocarea nu a fost găsită',
  YOU_ARE_NOT_ALLOWED_TO_REGISTER_THIS_PASSKEY:
    'Nu ai permisiunea de a înregistra această cheie de acces',
  FAILED_TO_VERIFY_REGISTRATION: 'Verificarea înregistrării a eșuat',
  PASSKEY_NOT_FOUND: 'Cheia de acces nu a fost găsită',
  AUTHENTICATION_FAILED: 'Autentificarea a eșuat',
  UNABLE_TO_CREATE_SESSION: 'Nu s-a putut crea sesiunea',
  FAILED_TO_UPDATE_PASSKEY: 'Actualizarea cheii de acces a eșuat',
  INVALID_PHONE_NUMBER: 'Număr de telefon invalid',
  PHONE_NUMBER_EXIST: 'Numărul de telefon există deja',
  INVALID_PHONE_NUMBER_OR_PASSWORD: 'Număr de telefon sau parolă invalidă',
  UNEXPECTED_ERROR: 'Eroare neașteptată',
  OTP_NOT_FOUND: 'Codul OTP nu a fost găsit',
  PHONE_NUMBER_NOT_VERIFIED: 'Numărul de telefon nu este verificat',
  SUBSCRIPTION_NOT_FOUND: 'Abonamentul nu a fost găsit',
  SUBSCRIPTION_PLAN_NOT_FOUND: 'Planul de abonament nu a fost găsit',
  ALREADY_SUBSCRIBED_PLAN: 'Ești deja abonat la acest plan',
  UNABLE_TO_CREATE_CUSTOMER: 'Nu s-a putut crea clientul',
  FAILED_TO_FETCH_PLANS: 'Nu s-au putut încărca planurile',
  EMAIL_VERIFICATION_REQUIRED:
    'Trebuie să îți verifici emailul înainte de a te abona',
  SUBSCRIPTION_NOT_ACTIVE: 'Abonamentul nu este activ',
  SUBSCRIPTION_NOT_SCHEDULED_FOR_CANCELLATION:
    'Abonamentul nu este programat pentru anulare',
  OTP_NOT_ENABLED: 'OTP nu este activat',
  OTP_HAS_EXPIRED: 'OTP a expirat',
  TOTP_NOT_ENABLED: 'TOTP nu este activat',
  TWO_FACTOR_NOT_ENABLED: 'Autentificarea în doi pași nu este activă',
  BACKUP_CODES_NOT_ENABLED: 'Codurile de rezervă nu sunt activate',
  INVALID_BACKUP_CODE: 'Cod de rezervă invalid',
  INVALID_CODE: 'Cod invalid',
  TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE:
    'Prea multe încercări. Solicită un cod nou.',
  INVALID_TWO_FACTOR_COOKIE: 'Cookie-ul pentru doi factori este invalid',
  INVALID_USERNAME_OR_PASSWORD: 'Nume de utilizator sau parolă invalidă',
  USERNAME_IS_ALREADY_TAKEN:
    'Numele de utilizator este deja folosit. Încearcă altul.',
  USERNAME_TOO_SHORT: 'Numele de utilizator este prea scurt',
  USERNAME_TOO_LONG: 'Numele de utilizator este prea lung',
  INVALID_USERNAME: 'Numele de utilizator este invalid',
} satisfies AuthLocalization;
